import React from 'react';
import { makeStyles } from '@mui/styles';
import { find, propEq } from 'ramda';
import Avatar from '@mui/material/Avatar';

import { CRITERIA_OPTIONS } from '../../modals/SelectByCriteria/constants';
import { getLabelValue } from './model';
import palette from '../../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  labelRule: {
    color: palette.statuses.statusGreen,
    paddingRight: typography.pxToRem(5),
    textTransform: 'capitalize',
  },
  labelValue: {
    color: palette.map.key2,
    paddingLeft: typography.pxToRem(5),
    textTransform: 'capitalize',
    display: 'inline-block',
  },
  moreAccountLabel: {
    backgroundColor: palette.statuses.statusGreen,
    color: `${palette.typography.white.solid} !important`,
    fontSize: typography.pxToRem(16),
  },
}));

export const Label = ({ criteria, operator = '', value, rule }) => {
  const classes = useStyles();

  const criteriaLabel = find(propEq(criteria, 'value'), CRITERIA_OPTIONS);
  const valueLabel = getLabelValue({ criteria, value });

  return (
    <>
      <span className={classes.labelRule}>{rule}</span>
      <span>{criteriaLabel ? criteriaLabel.label : criteria}</span>
      {operator && <span className={classes.labelValue}>{operator}</span>}
      <span className={classes.labelValue}>{valueLabel}</span>
    </>
  );
};

export const MoreLabel = ({ criteriaCount }) => {
  const classes = useStyles();

  return (
    <Avatar className={classes.moreAccountLabel}>{`+${
      criteriaCount - 3
    }`}</Avatar>
  );
};
